<template lang="pug">
.tag(:class="{ 'tag-success': success, 'tag-danger': danger, 'tag-warning': awaiting || warning }")
  slot default tag text
</template>

<script>
export default {
  name: 'Tag',
  props: {
    success: {
      type: Boolean,
      default: false,
      required: false,
    },
    danger: {
      type: Boolean,
      default: false,
      required: false,
    },
    warning: {
      type: Boolean,
      default: false,
      required: false,
    },
    awaiting: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data: () => ({}),
};
</script>

<style lang="scss">
%tag {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: rgb(255, 255, 255);

  padding: 0 14px;
  border-radius: 3px;
  max-height: 30px;
  min-height: 30px;
  height: 30px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

$--success: rgb(0, 196, 129);
$--danger: rgb(255, 78, 78);
$--warning: rgb(255, 184, 78);

.tag {
  @extend %tag;
  background-color: rgba(179, 173, 173, 0.831);
  &-success {
    background-color: $--success;
    color: rgb(255, 255, 255);
  }
  &-danger {
    background-color: $--danger;
    color: rgb(255, 255, 255);
  }
  &-warning {
    background-color: $--warning;
    color: rgb(255, 255, 255);
  }
}
</style>
